import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { Text, H3 } from '@omilia/typography';
import Icon from '@omilia/icon';

export const SButton = styled.button`
  background-color: ${colors.COLOR_WHITE};
  border: 1px solid ${colors.COLOR_GREY_400};
  border-radius: 6px;
  display: block;
  flex-grow: 1;
  height: 146px;
  margin-right: 23px;
  text-align: center;
  width: 146px;

  &:active {
    background-color: ${colors.COLOR_BLUE_600};
  }

  &:hover {
    background-color: ${colors.COLOR_BLUE_100};
    border: 1px solid ${colors.COLOR_BLUE_600};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

export const SH3 = styled(H3)`
  color: ${colors.COLOR_GREY_1000};
  display: inline-flex;
  margin-left: 12px;
`;

export const SHeaderWrapper = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.COLOR_GREY_300};
  display: flex;
  padding: 17px 51px 16px 51px;
`;

export const SIcon = styled(Icon)`
  margin-top: 32px;
`;

export const SIconWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
`;

export const SIconText = styled(Text)`
  color: ${colors.COLOR_BLUE_600};
  margin-bottom: 32px;
  margin-top: 14px;
`;

export const SModalDescription = styled(Text)`
  color: ${colors.COLOR_GREY_1000};
  margin: 16px 51px;
`;

export const SForm = styled.form`
  width: 100%;
`;

export const SModalBodyWrapper = styled.div`
  min-height: 183px;
  position: relative;
  width: 100%;
`;
